import {
  CheckIcon,
  CloseIcon,
  ConsentOrdersNonFinancialSchema,
  InitialDetails,
  NonFinancialIcon,
  RadioSelect,
  RangeSlider,
  TextArea
} from "@fla/components";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

const fc = [
  "Buying materials at below market rate.",
  "Do-it-yourself renovations (e.g: painting, tiling, installing the kitchen, paving).",
  "Servicing motor vehicles (e.g: changing the oil, tyres, replacing the motor).",
  "Caring for children of the other person from another relationship.",
  "Caring for elderly parents or family members of the other person.",
  "Working unpaid, or below market rate, for a family business (e.g: paying suppliers, bookkeeping).",
  "Managing or working on an investment property."
];

const nfc = [
  "Household chores, general household maintenance and gardening (these are captured in the previous question).",
  "If you paid for someone else to do it (this is captured in the financial contributions question).",
  "If you received market rate for working for a family business.",
  "Caring for your own elderly parent or family members."
];

interface IProps {
  formId: string;
  store: InitialDetails;
  onSubmit: (values: InitialDetails) => void;
}

export default function NonFinancialContributions({ onSubmit, formId, store }: IProps) {
  const { handleSubmit, watch, setValue, control } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(ConsentOrdersNonFinancialSchema)
  });

  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-8 pb-8 border-b">
        <NonFinancialIcon classes="w-14 h-14 mx-auto mb-5" />

        <h3 className="text-center">Non-Financial Contributions</h3>
      </div>

      <div className="space-y-5">
        <p className="text-sm">
          <b>Non-Financial</b> contributions refers to things you or&nbsp;
          {store?.spouse?.first_name} did yourself that would cost you money if you paid someone else to do it. For
          example:
        </p>

        <ul className="text-sm space-y-3">
          {fc.map((item, idx) => (
            <li key={+idx} className="flex p-3 rounded-[10px] bg-[#f2f2f2]">
              <CheckIcon classes="fill-current text-green-600" />
              <p className="w-full pl-2">{item}</p>
            </li>
          ))}
        </ul>
      </div>

      <div className="space-y-5">
        <p className="text-sm">This is not a Non-Financial contribution:</p>

        <ul className="text-sm space-y-3">
          {nfc.map((item, idx) => (
            <li key={+idx} className="flex p-3 rounded-[10px] bg-[#f2f2f2]">
              <CloseIcon strokeColor="text-red-500" />
              <p className="w-full pl-2">{item}</p>
            </li>
          ))}
        </ul>
      </div>

      <RadioSelect
        title="Were the non-financial contributions generally equal?"
        control={control}
        name="contributions.contribution_non_financial_equal"
        id="contributions.contribution_non_financial_equal"
        options={["yes", "no"]}
        // wrapClassName="col-span-1"
        onChange={val => {
          if (val === "no") {
            setValue("contributions.contribution_non_financial", "50");
          } else {
            setValue("contributions.contribution_non_financial", "");
            setValue("contributions.contribution_non_financial_comments", "");
          }
        }}
      />

      {watch("contributions.contribution_non_financial_equal") === "no" ? (
        <>
          <RangeSlider
            title={
              <>
                How did you both contribute to Non-Financial contributions{" "}
                <span className="font-light">(optional)</span>
              </>
            }
            control={control}
            name="contributions.contribution_non_financial"
            id="contributions.contribution_non_financial"
            exName={store?.spouse?.first_name || "N/A"}
          />

          <TextArea
            title="Give details on why the non-financial contributions were not equal"
            control={control}
            name="contributions.contribution_non_financial_comments"
            id="contributions.contribution_non_financial_comments"
            placeholder="details"
            // classes="col-span-1"
          />
        </>
      ) : null}
    </form>
  );
}

/*
list of Australian States
Overseas 

show the country (drop down)
shw input box - overseas_state

*/
